import {
  configureLinesChartValidates,
  configureDataValidate,
  resultsetWithFields,
} from 'vlcishared';
import { yAxisFormat, configureDataLine, calculateXAxisStart } from '../common';
import * as constants from '../constants/constants';

export function echartAnellCiclista(vis, datos) {
  const color = constants.COLORS.slice();
  const datosArray = datos.resultset || datos;

  // Obtenemos los datos ordenados
  const cleanData = configureDataLine(datosArray, color, false);
  const date = cleanData[1];
  const xAxisData = Array.from(date.values());
  const legendData = cleanData[2];
  const datazoomStart = calculateXAxisStart(date.size);

  // Obtenemos los datos para formar la serie
  const resultSet = resultsetWithFields(datos);
  const kpiValidList = [
    'KpiValid-30-Trafico-Bicicletas-Anillo',
    'KpiValid-365-Trafico-Bicicletas-Anillo',
  ];
  const kpiInvalidList = ['Kpi-Trafico-Bicicletas-Anillo'];
  const seriesData = configureDataValidate(
    resultSet,
    cleanData[0],
    kpiValidList,
    kpiInvalidList,
  );

  const specificOptions = {
    title: {
      text: 'TRÀNSIT CICLISTA: ANELL CICLISTA',
    },
    legend: {
      show: true,
      data: legendData,
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
    },
    yAxis: {
      name: 'Bicicletes',
      axisLabel: {
        formatter: yAxisFormat,
      },
    },
    dataZoom: {
      show: true,
      data: xAxisData,
      start: datazoomStart,
    },
    toolbox: {
      show: true,
    },
  };

  configureLinesChartValidates(
    'chartAnellCiclista',
    seriesData,
    specificOptions,
  );
}
